import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx, _cache) {
  const _component_ContainerTag = _resolveComponent("ContainerTag")
  const _component_Button = _resolveComponent("Button")

  return (_ctx.isTopMiddle)
    ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: _normalizeClass(_ctx.getClass('component-wrapper')),
        ref: "componentWrapper",
        style: _normalizeStyle(_ctx.styleContainer)
      }, [
        (!!_ctx.imageUrl)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('wrapper-image')),
              style: {"width":"100%"}
            }, [
              _createElementVNode("img", {
                ref: "imageEvent",
                class: _normalizeClass(_ctx.getClass('img-event')),
                src: _ctx.imageUrl,
                alt: _ctx.imageAlt,
                width: "100%",
                style: _normalizeStyle({ height: _ctx.imgHeight, aspectRatio: _ctx.imgAspectRatio, objectFit: _ctx.imgObjectFit, borderRadius: _ctx.imgBorderRadius })
              }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_1),
              (_ctx.toggleTag.isImageTag)
                ? (_openBlock(), _createBlock(_component_ContainerTag, {
                    key: 0,
                    "tag-style": _ctx.styleTag,
                    text: _ctx.tagContent
                  }, null, 8 /* PROPS */, ["tag-style", "text"]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('tag-container')),
          ref: "tagContent"
        }, [
          (_ctx.toggleTag.isContentTag)
            ? (_openBlock(), _createBlock(_component_ContainerTag, {
                key: 0,
                "tag-style": _ctx.styleTag,
                text: _ctx.tagContent
              }, null, 8 /* PROPS */, ["tag-style", "text"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClass('content-wrapper')),
            ref: "contentWrapper"
          }, [
            (_ctx.line1)
              ? (_openBlock(), _createElementBlock("h4", {
                  key: 0,
                  class: _normalizeClass(_ctx.getClass('title')),
                  style: _normalizeStyle({ ..._ctx.styleLine1 })
                }, _toDisplayString(_ctx.line1.content), 7 /* TEXT, CLASS, STYLE */))
              : _createCommentVNode("v-if", true),
            (_ctx.line2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  ref: "description",
                  class: _normalizeClass(_ctx.getClass('description')),
                  style: _normalizeStyle({ ..._ctx.styleLine2 })
                }, _toDisplayString(_ctx.line2.content), 7 /* TEXT, CLASS, STYLE */))
              : _createCommentVNode("v-if", true),
            (_ctx.html)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  ref: "html_carousel",
                  class: _normalizeClass(_ctx.getClass('html_carousel')),
                  style: _normalizeStyle({ ..._ctx.styleHtml }),
                  innerHTML: _ctx.html && _ctx.html.content
                }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_2))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ], 2 /* CLASS */),
        _createElementVNode("button", {
          type: "button",
          ref: "custom_ellipsis",
          class: _normalizeClass(_ctx.getClass('custom_ellipsis')),
          style: _normalizeStyle(_ctx.styleEllipsis),
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, null, 6 /* CLASS, STYLE */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('tag-container')),
          ref: "tagButton"
        }, [
          (_ctx.toggleTag.isButtonTag)
            ? (_openBlock(), _createBlock(_component_ContainerTag, {
                key: 0,
                "tag-style": _ctx.styleTag,
                text: _ctx.tagContent
              }, null, 8 /* PROPS */, ["tag-style", "text"]))
            : _createCommentVNode("v-if", true),
          (_ctx.showButton)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                ref: "buttonWrapper",
                class: _normalizeClass(_ctx.getClass('button-wrapper'))
              }, [
                _createCommentVNode(" Render all fixed buttons, for backward compatibility "),
                (_ctx.button1 && _ctx.button1.label)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      component: _ctx.button1Component,
                      messageContentsettings: _ctx.settings,
                      onClick: _ctx.onClickButton,
                      customStyle: _ctx.styleButton1
                    }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.button2 && _ctx.button2.label)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      component: _ctx.button2Component,
                      messageContentsettings: _ctx.settings,
                      onClick: _ctx.onClickButton,
                      customStyle: _ctx.styleButton2
                    }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.button3 && _ctx.button3.label)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      component: _ctx.button3Component,
                      messageContentsettings: _ctx.settings,
                      onClick: _ctx.onClickButton,
                      customStyle: _ctx.styleButton3
                    }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Render all dynamic buttons "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allDynamicButtons, (buttonItem) => {
                  return (_openBlock(), _createBlock(_component_Button, {
                    key: buttonItem.key,
                    component: buttonItem.component,
                    messageContentsettings: _ctx.settings,
                    onClick: _ctx.onClickButton,
                    customStyle: buttonItem.style
                  }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                }), 128 /* KEYED_FRAGMENT */))
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        (_ctx.toggleTag.isCardTag)
          ? (_openBlock(), _createBlock(_component_ContainerTag, {
              key: 1,
              "tag-style": _ctx.styleTag,
              text: _ctx.tagContent
            }, null, 8 /* PROPS */, ["tag-style", "text"]))
          : _createCommentVNode("v-if", true)
      ], 6 /* CLASS, STYLE */))
    : (_openBlock(), _createElementBlock("li", {
        key: 1,
        class: _normalizeClass(_ctx.getClass('component-wrapper')),
        ref: "componentWrapper",
        style: _normalizeStyle(_ctx.styleContainer)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('top-wrapper')),
          ref: "topWrapper"
        }, [
          (!!_ctx.imageUrl)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(_ctx.getClass('wrapper-image'))
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass(_ctx.getClass('img-event')),
                  ref: "imageEvent",
                  src: _ctx.imageUrl,
                  alt: _ctx.imageAlt,
                  style: _normalizeStyle({ width: _ctx.imgWidth, height: _ctx.imgHeight, aspectRatio: _ctx.imgAspectRatio, objectFit: _ctx.imgObjectFit, borderRadius: _ctx.imgBorderRadius })
                }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_3),
                (_ctx.toggleTag.isImageTag)
                  ? (_openBlock(), _createBlock(_component_ContainerTag, {
                      key: 0,
                      "tag-style": _ctx.styleTag,
                      text: _ctx.tagContent
                    }, null, 8 /* PROPS */, ["tag-style", "text"]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.getClass('tag-container')),
            ref: "tagContent"
          }, [
            (_ctx.toggleTag.isContentTag)
              ? (_openBlock(), _createBlock(_component_ContainerTag, {
                  key: 0,
                  "tag-style": _ctx.styleTag,
                  text: _ctx.tagContent
                }, null, 8 /* PROPS */, ["tag-style", "text"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.getClass('content-wrapper')),
              ref: "contentWrapper"
            }, [
              (_ctx.line1)
                ? (_openBlock(), _createElementBlock("h4", {
                    key: 0,
                    class: _normalizeClass(_ctx.getClass('title')),
                    style: _normalizeStyle({ ..._ctx.styleLine1 })
                  }, _toDisplayString(_ctx.line1.content), 7 /* TEXT, CLASS, STYLE */))
                : _createCommentVNode("v-if", true),
              (_ctx.line2)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    ref: "description",
                    style: _normalizeStyle({ ..._ctx.styleLine2 }),
                    class: _normalizeClass(_ctx.getClass('description'))
                  }, _toDisplayString(_ctx.line2.content), 7 /* TEXT, CLASS, STYLE */))
                : _createCommentVNode("v-if", true),
              (_ctx.html)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    ref: "html_carousel",
                    class: _normalizeClass(_ctx.getClass('html_carousel')),
                    style: _normalizeStyle({ ..._ctx.styleHtml }),
                    innerHTML: _ctx.html && _ctx.html.content
                  }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_4))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */)
          ], 2 /* CLASS */)
        ], 2 /* CLASS */),
        _createElementVNode("button", {
          type: "button",
          ref: "custom_ellipsis",
          class: _normalizeClass(_ctx.getClass('custom_ellipsis')),
          style: _normalizeStyle(_ctx.styleEllipsis),
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.showModal && _ctx.showModal(...args)))
        }, null, 6 /* CLASS, STYLE */),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.getClass('tag-container')),
          ref: "tagButton"
        }, [
          (_ctx.toggleTag.isButtonTag)
            ? (_openBlock(), _createBlock(_component_ContainerTag, {
                key: 0,
                "tag-style": _ctx.styleTag,
                text: _ctx.tagContent
              }, null, 8 /* PROPS */, ["tag-style", "text"]))
            : _createCommentVNode("v-if", true),
          (_ctx.showButton)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(_ctx.getClass('button-wrapper')),
                ref: "buttonWrapper"
              }, [
                (_ctx.button1 && _ctx.button1.label)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      component: _ctx.button1Component,
                      messageContentsettings: _ctx.settings,
                      onClick: _ctx.onClickButton,
                      customStyle: _ctx.styleButton1
                    }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.button2 && _ctx.button2.label)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      component: _ctx.button2Component,
                      messageContentsettings: _ctx.settings,
                      onClick: _ctx.onClickButton,
                      customStyle: _ctx.styleButton2
                    }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.button3 && _ctx.button3.label)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 2,
                      component: _ctx.button3Component,
                      messageContentsettings: _ctx.settings,
                      onClick: _ctx.onClickButton,
                      customStyle: _ctx.styleButton3
                    }, null, 8 /* PROPS */, ["component", "messageContentsettings", "onClick", "customStyle"]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */),
        (_ctx.toggleTag.isCardTag)
          ? (_openBlock(), _createBlock(_component_ContainerTag, {
              key: 0,
              "tag-style": _ctx.styleTag,
              text: _ctx.tagContent
            }, null, 8 /* PROPS */, ["tag-style", "text"]))
          : _createCommentVNode("v-if", true)
      ], 6 /* CLASS, STYLE */))
}